"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const cutter_fallback_png_1 = __importDefault(require("../../../img/cutter-fallback.png"));
const media_1 = require("../../helper/media");
const AssetsCutterTableExpandedItem = (props) => {
    const { data } = props;
    const imageProps = data?.media ? (0, media_1.imageSourceFromMedia)(data.media) : { src: cutter_fallback_png_1.default };
    return (react_1.default.createElement("div", { className: "znd-assets-table-sub" },
        react_1.default.createElement("div", { className: "d-flex flex-row" },
            react_1.default.createElement("img", { className: "znd-assets-table-sub__image", ...imageProps })),
        react_1.default.createElement("div", { className: "znd-assets-table-sub__buttons" })));
};
exports.default = AssetsCutterTableExpandedItem;
